module.exports = __webpack_public_path__ + "img/telefonos-menu.72947357.svg";